import {styled} from "@mui/material/styles"

export const StyledMenuContainer = styled("div")`
    flex: 1;
`
